$(window).on("load",function(){
});
$(function(){
	//上部トピックススライダー
	const home_topics_kiji = new Swiper('.home_topics_kiji .swiper', {
		loop: true,
		loopAdditionalSlides: 1,
		// slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		autoHeight:true,
		breakpoints: {
			// when window width is >= 640px
			768: {
				autoHeight:false,
			}
		}
	});
	//上部トピックススライダー
	const hs_boutou_imgs = new Swiper('.hs_boutou_imgs .swiper', {
		// slidesPerView: 'auto',
		loop: true,
		loopAdditionalSlides: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		speed: 1000,
		autoplay: {
			delay: 3000,
			disableOnInteraction:false,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
});